import React, { PropsWithChildren } from "react";
import { Button } from "../../ui-library/Button/Button.tsx";
import { TextArea } from "../../ui-library/TextArea/TextArea.tsx";
import { ArrowIcon } from "./ArrowIcon.tsx";
import styles from "./ChatBox.module.css";

interface ChatBoxProps {
  onSubmit: (value: string) => void;
  processing?: boolean;
  submitDisabled?: boolean;
}

export const ChatBox: React.FC<PropsWithChildren<ChatBoxProps>> = ({
  onSubmit,
  processing,
  submitDisabled,
  children,
}) => {
  const [value, setValue] = React.useState("");
  const submitHandler = () => {
    if (!value.trim()) return;
    onSubmit(value);
    setValue("");
  };
  return (
    <div className={styles.Container}>
      <div className={styles.TopBar}>{children}</div>

      <hr className={styles.HorizontalSeparator} />
      <div className={styles.TextboxContainer}>
        <TextArea
          onChange={(value) => {
            setValue(value);
          }}
          value={value}
          disabled={processing}
          className={styles.Textbox}
          placeholder={processing ? "Processing..." : "Ask me about a topic..."}
          onSubmit={submitHandler}
        />
        <Button
          className={styles.Button}
          onClick={submitHandler}
          disabled={processing || submitDisabled || !value}
        >
          <ArrowIcon />
        </Button>
      </div>
    </div>
  );
};
